import './Privacy.css';
import SEO from '../components/seo/SEO';

export default function Privacy() {
  return (
    <>
    <SEO
      title="Privacy Policy | Explorelrt"
      description="Read the Explorelrt privacy policy, including information about log files, cookies, third-party services, and visitor rights."
    />

    <main className="privacyHero">
      <h1>Privacy Policy</h1>

      <section className="privacySection">
        <h2>Effective Date: January 1, 2026</h2>
        <p>
          At Explorelrt, reachable from https://explorelrt.com, one of our main priorities is the
          privacy of our visitors. This document outlines the types of information we collect and how we use it.
        </p>
      </section>

      <section className="privacySection">
        <h2>Information We Collect</h2>
        <ul className="privacyList">
          <li>
            <strong>Log Files: </strong>
            Like most websites, we use log files. This includes IP addresses, browser type, Internet Service Provider
            (ISP), date/time stamps, and referring/exit pages. This isn&apos;t linked to personally identifiable
            information; it is used to analyze trends.
          </li>
          <li>
            <strong>Cookies: </strong>
            We use &quot;cookies&quot; to store information about your preferences and the pages you access to optimize your
            experience.
          </li>
          <li>
            <strong>Personal Data: </strong>
            If you subscribe to our newsletter or leave a comment, we may collect your name and email address. We will
            never sell this information to third parties.
          </li>
        </ul>
      </section>

      <section className="privacySection">
        <h2>Third-Party Services</h2>
        <p>
          We may use third-party service providers (like Google Analytics or ad networks) to monitor and analyze the
          use of our service. These providers have their own privacy policies.
        </p>
      </section>

      <section className="privacySection">
        <h2>Your Rights</h2>
        <p>
          You have the right to request access to the data we have on you, request corrections, or ask us to delete
          your information entirely.
        </p>
      </section>
    </main>
    </>
  );
}
